import React from 'react';

import { css } from '@emotion/css';
import { Theme, Typography } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { PatientListItem } from '@/models/PatientSummaryModel.ts';
import { doctorFormattedName } from '@/models/UserModel.ts';

type ReferentDoctorColumnProps = CellContext<PatientListItem, unknown>;

export const ReferentDoctorColumn: React.FC<ReferentDoctorColumnProps> = ({
  row,
}) => {
  const styles = useStyles(makeStyles);
  const doctor = row.original.doctor;

  return (
    <div className={styles.container}>
      <Typography className={styles.name} variant="body">
        {doctor ? doctorFormattedName(doctor.familyName, doctor.givenName) : ''}
      </Typography>
    </div>
  );
};

export const ReferentDoctorHeader: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeHeaderStyles);

  return (
    <div className={styles.container}>
      <Typography>{t('pages.patients.referentDoctor')}</Typography>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: ${theme.spacing(8)};
  `,
  name: css`
    font-weight: bold;
    text-wrap: wrap;
  `,
});

const makeHeaderStyles = () => ({
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  `,
});
